import React, { Component } from 'react';
import styles from './SearchPage.module.css';
import Divider from '../../components/Divider';
import Grid from '../../components/Grid';
import queryString from 'query-string';
import {
  fetchModels,
  getSearchedModels,
  setSearchedModels,
} from '../../modules/models';
import TableView from '../../components/TableView';
import {
  fetchMaterials,
  getSearchedMaterials,
  setSearchedMaterials,
} from '../../modules/materials';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import { getSelected, setView, setSelected } from '../../modules/explorer';

const headers = {
  models: [
    'Product Name',
    'Collection Code',
    'Item Type Code',
    'Season Code',
    'Version',
    'Status',
  ],
  materials: [
    'Material Name',
    'Tags',
    'Choice Code',
    'Season Code',
    'Lighting',
    'Status',
  ],
};

class SearchPage extends Component {
  state = {
    loading: true,
    materials: [],
    displayType: 'list',
    entitystate: 'Active',
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  componentDidMount = async () => {
    const { setSelected } = this.props;
    const { loading } = this.state;
    const query = queryString.parse(window.location.search);
    query.limit = 1000;
    query.friendlyName = query.value;
    query.state = 'All';
    delete query.value;
    const { fetchModels, fetchMaterials } = this.props;
    await fetchModels(query, 'search');
    await fetchMaterials(query, 'search');
    setSelected('models', {});
    setSelected('materials', {});
    this.setState({ loading: false });
  };

  componentWillUnmount() {
    const { setView, setSelected } = this.props;
    setView(null);
    setSelected('models', {});
    setSelected('materials', {});
  }

  componentWillUnmount = () => {
    const { setSearchedModels, setSearchedMaterials } = this.props;
    setSearchedModels({});
    setSearchedMaterials({});
  };

  searchItems = async value => {
    if (!value) value = this.refs['search'].value;
    if (!value) return;
    const query = {
      limit: 1000,
      friendlyName: value,
      state: 'All',
    };
    const { fetchModels, fetchMaterials, setSelected } = this.props;
    setSelected('models', {});
    setSelected('materials', {});
    await fetchModels(query, 'search');
    await fetchMaterials(query, 'search');
    const { router } = this.context;
    router.history.push(`/search?value=${value}`);
  };

  navTo = (id, cat) => {
    const { router } = this.context;
    const url = `/${cat}${id ? `/${id}` : ''}`;
    router.history.push(url);
  };

  filterByState = data => {
    this.setState({ entitystate: data && data.value });
  };

  formatModelData = (items, catogary) => {
    let content = [];
    if (catogary === 'models') {
      content = Object.keys(items).map(k => [
        { label: items[k].friendlyName, value: items[k]._id },
        items[k]['metadata']['Collection Code'],
        items[k]['metadata']['Item Code'],
        items[k]['metadata']['Season'],
        items[k]['version'],
        items[k]['pipeline'],
      ]);
    } else if (catogary === 'materials') {
      content = Object.keys(items).map(k => [
        { label: items[k].friendlyName, value: items[k]._id },
        items[k].tags.join(','),
        items[k]['metadata']['Material Code'],
        items[k]['metadata']['Season'],
        items[k]['metadata']['Lighting'],
        items[k]['pipeline'],
      ]);
    }
    return content;
  };

  changeDisplayType = () => {
    const { displayType } = this.state;
    const newDisplay = displayType === 'list' ? 'carousel' : 'list';
    this.setState({ displayType: newDisplay });
  };

  onSelect = async (catogary, id, value) => {
    const { setView, setSelected } = this.props;
    let selected = this.props[`selected${catogary}`];
    if (typeof id === 'object') {
      if (Object.keys(selected).length === 0)
        setView({
          page: 'listview',
          catogary: catogary,
        });
      selected = id;
      if (Object.keys(selected).length === 0) setView(null);
    } else {
      if (value) {
        if (Object.keys(selected).length === 0)
          setView({
            page: 'listview',
            catogary: catogary,
          });
        selected[id] = true;
      } else {
        delete selected[id];
        if (Object.keys(selected).length === 0) setView(null);
      }
    }
    setSelected(catogary, selected);
  };

  renderGrid = catogary => {
    const { createJob } = this.props;
    const items = this.props[catogary];
    const selected = this.props[`selected${catogary}`];
    const data = Object.assign({}, items);
    if (!items) return null;
    const { entitystate } = this.state;
    for (let i in data) {
      if (data[i].state !== entitystate) delete data[i];
    }
    if (Object.keys(data).length > 0) {
      return (
        <Grid
          createJob={createJob}
          items={data}
          selected={selected}
          onSelect={this.onSelect.bind(this, catogary)}
          navTo={this.navTo}
          catogary={catogary}
        />
      );
    } else {
      return <p className={styles.noResult}>You search yield no models</p>;
    }
  };

  renderList = catogary => {
    const items = this.props[catogary];
    if (!items) return null;
    const data = Object.assign({}, items);
    const selected = this.props[`selected${catogary}`];
    const { entitystate } = this.state;
    for (let i in data) {
      if (data[i].state !== entitystate) delete data[i];
    }
    if (Object.keys(data).length === 0) {
      return <p className={styles.noResult}>You search yield no models</p>;
    } else {
      const content = this.formatModelData(data, catogary);
      return (
        <TableView
          selected={selected}
          headers={headers[catogary]}
          data={content}
          onSelect={this.onSelect.bind(this, catogary)}
          onClick={id => this.navTo(id, catogary)}
          rowColor="#2375C2"
        />
      );
    }
  };

  render() {
    const { displayType, entitystate, loading } = this.state;
    const { models, materials } = this.props;
    if (loading) {
      return (
        <div className={styles.container}>
          <div className={styles.header}> Search </div>
          <div className={styles.resultContainer}>
            <img src={'/img/loading.svg'} />
          </div>
        </div>
      );
    }
    const hasResult =
      Object.keys(models).length > 0 || Object.keys(materials).length > 0;
    if (!hasResult) {
      return (
        <div className={styles.container}>
          <div className={styles.header}> Search </div>
          <div className={styles.resultContainer}>
            {!hasResult && (
              <div className={styles.noResult}>
                Your search yielded no results
              </div>
            )}
          </div>
          <Divider />
          <div className={styles.searchAgain}>
            <div className={styles.title}> Search again </div>

            <div className={styles.searchContainer}>
              <img
                onClick={e => this.searchItems()}
                alt="search"
                src="/img/search.svg"
                className={styles.searchIcon}
              />
              <input
                ref="search"
                className={styles.search}
                placeholder="Search"
                onKeyPress={e => {
                  if (e.key === 'Enter') {
                    this.searchItems();
                  }
                }}
              />
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className={styles.container}>
          <div className={styles.headerContainer}>
            <div className={styles.catHeader}> Models</div>
            <div className={styles.headerFilter}>
              <img
                src={`/img/${displayType}.png`}
                className={styles.displayType}
                onClick={this.changeDisplayType}
              />
              <div className={styles.tagLabel}>State </div>
              <ReactSelect
                className={styles.tagDropdown}
                onChange={this.filterByState}
                placeholder={entitystate}
                value={entitystate}
                options={[
                  { label: 'Active', value: 'Active' },
                  { label: 'Discontinued', value: 'Discontinued' },
                ]}
              />
            </div>
          </div>
          <Divider />
          {displayType === 'list'
            ? this.renderGrid('models')
            : this.renderList('models')}
          <div className={styles.headerContainer}>
            <div className={styles.catHeader}> Materials</div>
            <div className={styles.headerFilter}>
              <img
                src={`/img/${displayType}.png`}
                className={styles.displayType}
                onClick={this.changeDisplayType}
              />
              <div className={styles.tagLabel}>State </div>
              <ReactSelect
                className={styles.tagDropdown}
                onChange={this.filterByState}
                placeholder={entitystate}
                value={entitystate}
                options={[
                  { label: 'Active', value: 'Active' },
                  { label: 'Discontinued', value: 'Discontinued' },
                ]}
              />
            </div>
          </div>{' '}
          <Divider />
          {displayType === 'list'
            ? this.renderGrid('materials')
            : this.renderList('materials')}
        </div>
      );
    }
  }
}

export default connect(
  state => ({
    models: getSearchedModels(state),
    materials: getSearchedMaterials(state),
    selectedmodels: getSelected('models', state),
    selectedmaterials: getSelected('materials', state),
  }),
  {
    fetchModels,
    fetchMaterials,
    setSearchedModels,
    setSearchedMaterials,
    setView,
    setSelected,
  }
)(SearchPage);



// WEBPACK FOOTER //
// ./src/containers/SearchPage/index.js